import {
  Card,
  Description,
  Details,
  Image,
  Tag,
  Tags,
  Title,
} from "../../CommonStyles/Card";

const ProjectCard = ({ project, setOpenModalProject }) => {
  return (
    <Card onClick={() => setOpenModalProject({ state: true, project: project })}>
      <Image src={project.image} />
      <Tags>
        {project.tags?.map((tag, index) => (
          <Tag key={index}>{tag}</Tag>
        ))}
      </Tags>
      <Details>
        <Title>{project.title}</Title>
        <Description>{project.description}</Description>
      </Details>
    </Card>
  );
};

export default ProjectCard;
